// extracted by mini-css-extract-plugin
export var currencyInput = "_n5-1";
export var currencySymbol = "_n5-0";